/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { MatButtonToggleGroup, MatButtonToggleGroupMultiple, MatButtonToggle } from './button-toggle';
import { MatCommonModule } from '@angular/material/core';
import { UNIQUE_SELECTION_DISPATCHER_PROVIDER } from '@angular/cdk/collections';
import { A11yModule } from '@angular/cdk/a11y';
var MatButtonToggleModule = (function () {
    function MatButtonToggleModule() {
    }
    MatButtonToggleModule.decorators = [
        { type: NgModule, args: [{
                    imports: [MatCommonModule, A11yModule],
                    exports: [
                        MatButtonToggleGroup,
                        MatButtonToggleGroupMultiple,
                        MatButtonToggle,
                        MatCommonModule,
                    ],
                    declarations: [MatButtonToggleGroup, MatButtonToggleGroupMultiple, MatButtonToggle],
                    providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER]
                },] },
    ];
    /**
     * @nocollapse
     */
    MatButtonToggleModule.ctorParameters = function () { return []; };
    return MatButtonToggleModule;
}());
export { MatButtonToggleModule };
function MatButtonToggleModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatButtonToggleModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatButtonToggleModule.ctorParameters;
}
//# sourceMappingURL=button-toggle-module.js.map